module.exports = __webpack_public_path__ + "static/media/203B-1303B.305acabb.png";